import { render, staticRenderFns } from "./PromotedBuyBox.vue?vue&type=template&id=fd1f53ea&scoped=true"
import script from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./PromotedBuyBox.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PromotedBuyBox.vue?vue&type=style&index=0&id=fd1f53ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1f53ea",
  null
  
)

export default component.exports